import * as React from "react";
import { IconButton, Link, Typography, makeStyles } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

import { storage } from "@/utils/storage";

export const NEW_SITE_URL =
  "https://fapinstructor.com/?utm_source=legacy&utm_medium=banner&utm_campaign=legacy-migration";

const DISMISSED_KEY = "new_site_banner_dismissed";

const useStyles = makeStyles((theme) => ({
  banner: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(1),
    padding: theme.spacing(0.5, 1, 0.5, 2),
    backgroundColor: "#212121",
    color: "#fff",
    textAlign: "center",
  },
  message: {
    flex: 1,
  },
  link: {
    color: theme.palette.secondary.light,
    fontWeight: "bold",
    whiteSpace: "nowrap",
  },
  close: {
    color: "#fff",
  },
}));

function capture(event: string) {
  window.posthog?.capture(event, { path: window.location.pathname });
}

/**
 * Slim banner shown above the nav bar that sends legacy visitors to the new
 * site. Dismissal is remembered in localStorage so regulars aren't nagged.
 */
export function NewSiteBanner() {
  const classes = useStyles();
  const [dismissed, setDismissed] = React.useState(() =>
    storage.getItem<boolean>(DISMISSED_KEY, false)
  );

  if (dismissed) {
    return null;
  }

  function handleDismiss() {
    storage.setItem(DISMISSED_KEY, true);
    setDismissed(true);
    capture("legacy_banner_dismissed");
  }

  return (
    <div className={classes.banner} role="region" aria-label="New site">
      <Typography variant="body2" className={classes.message}>
        Fap Instructor has a new home.{" "}
        <Link
          href={NEW_SITE_URL}
          className={classes.link}
          onClick={() => capture("legacy_banner_clicked")}
        >
          Try the new version →
        </Link>
      </Typography>
      <IconButton
        size="small"
        aria-label="Dismiss"
        className={classes.close}
        onClick={handleDismiss}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </div>
  );
}
